<template>
  <a-flex gap="large">
    <router-view class="left-side-req" />

    <SupportUserRequests class="right-side-req" />
  </a-flex>
</template>

<script setup lang="ts">
import SupportUserRequests from "@/components/settings/support/user/requests/SupportUserRequests.vue";
import { useSupportUserStore } from "@/stores/support/support-user.store";
import { useChatStore } from "@/stores/chat/chat.store";
import { onMounted, onUnmounted } from "vue";

const supportUserStore = useSupportUserStore();
const chatStore = useChatStore();

onMounted(async () => {
  await supportUserStore.initialize();
});

onUnmounted(async () => {
  await chatStore.clearAllData();
});
</script>

<style scoped lang="scss">
.left-side-req {
  flex: 1 1 60%;
}
.right-side-req {
  flex: 1 1 40%;
  overflow: hidden auto;
}
</style>
